import { useMemo } from 'react';

import useSettings from './useSettings';
import { findValidLocale } from './findValidLocale';

export function useDefaultLocale(): string {
  const { defaultLocale, locales } = useSettings();

  return useMemo(() => {
    const validLocale = findValidLocale(locales, defaultLocale);
    return validLocale ? validLocale.code : defaultLocale;
  }, [defaultLocale, locales]);
}

export default useDefaultLocale;
